/**
 * The registrable domains a visitor may be carried across by the prodantix
 * SDK's link decoration: every Bomdisoft product apex, and nothing a customer
 * of a product serves (a clepit tenant's site on clepit.space, a customer's own
 * domain), since a Bomdisoft visitor id has no business on a page whose
 * visitors are the customer's. One list, so every surface ships the same one.
 */
export const BOMDISOFT_LINKED_DOMAINS: readonly string[] = ['bomdisoft.com', 'clepit.com', 'devjuju.com', 'gamblish.org', 'njangy.com', 'pieleaf.com', 'prodantix.com', 'workadabra.com'];
